/** Shared Case Images lookup. Callers own their swatch/placeholder fallbacks. */
(function () {
  'use strict';

  window.theme = window.theme || {};
  if (window.theme.caseImages) return;

  // Catalog option handles, including the aliases used by the role products.
  // A Weekly Pill size can describe a single case or a magnetic role product;
  // only an explicit physical side selects its magnetic image.
  var SIZE_FIELDS = {
    'nano-pill-case': { single: 'nano_pill' },
    'nano-vitamin-case': { single: 'nano_vitamin' },
    'mission-pill-case': { single: 'mission_pill' },
    'mission-vitamin-case': { single: 'mission_vitamin' },
    'weekly-xs-case': { single: 'weekly_xs' },
    'weekly-xs-pill-case': { single: 'weekly_xs' },
    'weekly-pill-case': { single: 'weekly_pill', magnetic: 'pill' },
    'weekly-vitamin-case': { single: 'weekly_vitamin', magnetic: 'vitamin' },
    'weekly-vitamin-xl-case': { single: 'weekly_vitamin_xl', magnetic: 'vitamin_xl' },
    'weekly-vitamin-2xl-case': { single: 'weekly_vitamin_2xl' },
    'weekly-am-pm-pill-case': { magnetic: 'pill' },
    'weekly-am-pm-vitamin-case': { magnetic: 'vitamin' },
    'weekly-am-pm-vitamin-xl-case': { magnetic: 'vitamin_xl' },
    '2-week-pill-case': { magnetic: 'pill' },
    '2-week-vitamin-case': { magnetic: 'vitamin' },
    '2-week-vitamin-xl-case': { magnetic: 'vitamin_xl' },
    'pill': { magnetic: 'pill', magnano: 'pill' },
    'pill-case': { magnetic: 'pill', magnano: 'pill' },
    'vitamin': { magnetic: 'vitamin', magnano: 'vitamin' },
    'vitamin-case': { magnetic: 'vitamin', magnano: 'vitamin' },
    'vitamin-xl': { magnetic: 'vitamin_xl', magnano: 'vitamin_xl' },
    'vitamin-xl-case': { magnetic: 'vitamin_xl', magnano: 'vitamin_xl' },
    'magnano-pill-case': { magnano: 'pill' },
    'magnano-vitamin-case': { magnano: 'vitamin' },
    'magnano-vitamin-xl-case': { magnano: 'vitamin_xl' },
    'magnano-am-pm-pill-case': { magnano: 'pill' },
    'magnano-am-pm-vitamin-case': { magnano: 'vitamin' },
    'magnano-am-pm-vitamin-xl-case': { magnano: 'vitamin_xl' }
  };

  function lookupKey(value) {
    return String(value || '').trim().toLowerCase()
      .replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function resolve(map, selection) {
    selection = selection || {};
    var colorKey = lookupKey(selection.colorKey);
    var sizeKey = lookupKey(selection.sizeKey);
    if (!map || !Object.prototype.hasOwnProperty.call(map, colorKey)
      || !Object.prototype.hasOwnProperty.call(SIZE_FIELDS, sizeKey)) return '';

    var images = map[colorKey];
    var size = SIZE_FIELDS[sizeKey];
    var side = selection.side;
    var field = size.single || '';
    if (selection.pockets != null) {
      var pockets = Number(selection.pockets);
      if (!size.magnano || side || !Number.isInteger(pockets) || pockets < 1 || pockets > 5) return '';
      field = 'magnano_' + size.magnano + '_' + pockets + '_pocket';
    } else if (side) {
      if (!size.magnetic || ['left', 'middle', 'right'].indexOf(side) === -1) return '';
      field = 'magnetic_' + size.magnetic + '_' + side;
    }

    if (!field || !images || !Object.prototype.hasOwnProperty.call(images, field)) return '';
    return typeof images[field] === 'string' ? images[field].trim() : '';
  }

  window.theme.caseImages = { resolve: resolve };
})();
